import axios from "axios";
import { toast } from "react-toastify";

const requestInstance = axios.create();

let token = localStorage.getItem("token") || "";

requestInstance.interceptors.request.use(
  (config) => {
    const connection = navigator.onLine;
    token = localStorage.getItem("token") || "";
    if (connection === false) {
      toast.error("No Internet Connection");
      return false;
    }

    if (token) {
      if (config.method === "patch" || config.method === "post") {
        config.headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        };
      } else {
        config.headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
      }
    } else {
      config.headers = {
        "Content-Type": "application/json",
      };
    }

    return config;
  },
  (error) => {
    toast.error(error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
requestInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      localStorage.clear();
      window.location.pathname = "/login";
    }
    return Promise.reject(error);
  }
);

export default requestInstance;
